import React from 'react';

import Header from 'components/CommonLayout/Header';
import Body from 'components/CommonLayout/Body';
import { useIntl } from 'react-intl';

interface message {
  id: string;
}
interface CommonLayoutProps {
  title: message;
  content: React.ReactNode;
  icon?: React.ReactNode;
  subTitle?: string;
  fullscreen?: boolean;
}

const CommonLayout = ({
  title,
  content,
  icon,
  subTitle,
  fullscreen,
}: CommonLayoutProps) => {
  const pageTitle = useIntl().formatMessage({ id: title.id });
  return (
    <>
      <Header title={pageTitle} icon={icon} subTitle={subTitle} />
      <Body content={content} fullscreen={fullscreen} />
    </>
  );
};

export default CommonLayout;
